import { call, debounce, put } from 'redux-saga/effects';
import { fetchResponsibilityApprovalRequestList } from '../../../../services/responsibilityApprovalRequestService';
import { AppAction } from '../../../../state/app';
import { FAILURE, REQUEST, SUCCESS } from '../../../../utils/actionTypeUtil';
import { pushNotificationMessage } from '../../../components/Notification';
import { FETCH_PENDING_APPROVAL_RESPONSIBILITY_LIST } from './pendingApprovalResponsibilityList.actions';

function* fetchPendingApprovalResponsibilityListSaga(action: AppAction) {
  try {
    yield put({ type: REQUEST(action.type) });
    const response = yield call(fetchResponsibilityApprovalRequestList, action.payload);
    const { data, headers } = response;
    yield put({ type: SUCCESS(action.type), payload: { data, headers } });
  } catch (error) {
    const errorMessage: string = error.response.data.message;
    yield put({ type: FAILURE(action.type), payload: { errorMessage } });
    yield put(pushNotificationMessage({ message: errorMessage, type: 'error' }));
  }
}

export default function* watchPendingApprovalResponsibilityList() {
  yield debounce(
    250,
    FETCH_PENDING_APPROVAL_RESPONSIBILITY_LIST,
    fetchPendingApprovalResponsibilityListSaga,
  );
}
